var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCuadernoPersonas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_3557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9999 13.2222V55.2222C55.9999 57.0787 55.3577 58.8592 54.2147 60.172C53.0716 61.4847 51.5212 62.2222 49.9047 62.2222H19.4285C17.8119 62.2222 16.2616 61.4847 15.1185 60.172C13.9754 58.8592 13.3333 57.0787 13.3333 55.2222V13.2222C13.3333 11.3657 13.9754 9.58523 15.1185 8.27247C16.2616 6.95972 17.8119 6.22222 19.4285 6.22222H49.9047C51.5212 6.22222 53.0716 6.95972 54.2147 8.27247C55.3577 9.58523 55.9999 11.3657 55.9999 13.2222Z",
    stroke: "#474747",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21.3333H16",
    stroke: "#474747",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 32H16",
    stroke: "#474747",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 42.9996V40.7774C25 39.5987 25.4917 38.4682 26.3668 37.6348C27.242 36.8013 28.429 36.333 29.6667 36.333H34.3333C35.571 36.333 36.758 36.8013 37.6332 37.6348C38.5083 38.4682 39 39.5987 39 40.7774V42.9996M46 43V40.7778C45.9941 39.7969 45.6476 38.8454 45.0145 38.0717C44.6447 37.6198 44.1894 37.2838 43.6758 37C43.3101 36.7979 38.693 37 41.0263 37M38.2632 23.5C38.1747 23.4312 39.9954 23.093 41.0263 23.5C41.4393 23.6987 42.3058 24.2654 42.6956 24.7257C43.3309 25.5053 43.6758 26.464 43.6758 27.4509C43.6758 28.4377 43.3309 29.3965 42.6956 30.176C42.0602 30.9556 41.1705 31.5115 40.1667 31.7563C38.7893 31.8429 38.9789 31.8527 37.4946 31.7563M27.3333 27.4443C27.3333 28.6231 27.825 29.7535 28.7002 30.587C29.5753 31.4205 30.7623 31.8887 32 31.8887C33.2377 31.8887 34.4247 31.4205 35.2998 30.587C36.175 29.7535 36.6667 28.6231 36.6667 27.4443C36.6667 26.2656 36.175 25.1352 35.2998 24.3017C34.4247 23.4682 33.2377 23 32 23C30.7623 23 29.5753 23.4682 28.7002 24.3017C27.825 25.1352 27.3333 26.2656 27.3333 27.4443Z",
    stroke: "#474747",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 42.6667H16",
    stroke: "#474747",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_3557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuadernoPersonas);
export default __webpack_public_path__ + "static/media/cuadernoPersonas.34d87388169701ac3dbac35beacb10dd.svg";
export { ForwardRef as ReactComponent };